import { render, staticRenderFns } from "./SalesEditForm.vue?vue&type=template&id=0288e87b&"
import script from "./SalesEditForm.vue?vue&type=script&lang=js&"
export * from "./SalesEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports